import React, { useEffect } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { logoutUser } from "../api";

const LogoutPage = () => {
  useEffect(() => {
    logoutUser();
  }, []);

  return (
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "calc(100vh - 64px)", flexDirection: "column", gap: 2 }}>
      <CircularProgress size={40} />
      <Typography variant="h6">Signing you out…</Typography>
    </Box>
  );
};

export default LogoutPage;
